import RoamingStore from '../../stores/RoamingStore';
import { inject, observer } from 'mobx-react';
import { TranslationsContext } from '@teliaee/telia-translate';
import { Grid, GridColumn, ISelectOption, Select, TSelectValue } from 'telia-front-react';
import * as React from 'react';

interface OperatorSelectionProps {
  roamingStore?: RoamingStore;
}

@observer
class OperatorSelection extends React.Component<OperatorSelectionProps> {
  static contextType = TranslationsContext;
  declare context: React.ContextType<typeof TranslationsContext>;
  public render() {
    const translate = this.context.translate;
    const { roamingStore } = this.props;

    if (!roamingStore.operatorSelectOptions) {
      return null;
    }
    return (
      <Grid id="operators">
        <GridColumn width={['md-4', 'xl-3']}>
          <Select
            id="select-roaming-operators"
            label={translate('roaming.operator.select')}
            options={roamingStore.operatorSelectOptions}
            value={roamingStore.selectedOperatorSelectOption}
            onChange={(selectedValue: TSelectValue) => roamingStore.selectOperator(selectedValue as ISelectOption)}
          />
        </GridColumn>
      </Grid>
    );
  }
}

export default inject('roamingStore')(OperatorSelection);
